import { ListItemType } from '@/types';

export type ListItemProps = ListItemType & {
  onItemClick: (action: ListItemAction, item: ListItemType) => void;
  isSubmitting: boolean;
};

export enum ListItemAction {
  delete = 'delete',
  edit = 'edit',
  view = 'view',
  submit = 'submit',
}
export type CreditUnionRow = {
  name: string;
  city: string;
  state: string;
  joinNumber: string;
  assets: number;
};
